<template>
  <div class="w-full shrink-0 cursor-pointer border-t border-gray-lightest">
    <span v-if="showCustomer" class="relative flex items-center">
      <a
        :href="accountUrl"
        class="flex w-full cursor-pointer items-center border-gray-lightest px-4 py-3 hover:bg-gray-lightest"
        title="Sign in"
      >
        <span class="flex h-8 w-8 items-center">
          <FontAwesomeIcon
            :icon="{ prefix: 'far', iconName: 'user-circle' }"
            aria-hidden="true"
            class="size-5 text-black"
          />
        </span>
        <span v-if="isLoggedIn">{{ customer?.firstname }}</span>
        <span v-else v-text="$t('mega_menu.login.label')" />
      </a>
    </span>
  </div>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { useCustomer } from '@/composables/UseCustomer.ts';

const accountUrl = window.account_url;
const useCustomerComposable = useCustomer();
const customer = useCustomerComposable.getCustomer();
const isLoggedIn = customer?.signin_token ? true : false;

defineProps({
  showCustomer: {
    type: Boolean,
    required: false,
    default: false,
  },
});
</script>
